export default [
  {
    name: 'institutionKnowledge',
    path: '/institutionKnowledge/index',
    component: () => import('@/views/institutionKnowledge/index'),
    meta: {
      title: '企标知识库'
    }
  },
]
